import { queryClient } from '../queryClient';

import { createChannelCollectionQueryOptions } from './queryOptions';

type PrefetchChannelCollectionArgs = {
  referenceId: string;
};

export function prefetchChannelCollection({ referenceId }: PrefetchChannelCollectionArgs) {
  return queryClient.prefetchQuery(createChannelCollectionQueryOptions({ referenceId }));
}
